// DESIGN-PROOF · Features · bilingual + environmental integration pass
//
// Composition refs : FEATURES_01..06_APPROVED.png (locked)
// Scene artwork    : /brand/features/G1..G6_*.png (byte-for-byte unchanged)
// Bilingual mech   : reuses existing LangContext + useLang() from App.js;
//                    local COPY table follows the established pattern.
//
// This route is the FROZEN VISUAL REFERENCE for production migration
// (LEVI_LANDING_V2_ENABLED). It composes the exact same shared section
// components under frontend/src/components/landing/* that the production
// V2 landing composes — so /design-proof/features and the production V2
// landing are pixel-identical by construction. Do not modify this file
// to make production match a changed implementation; production must be
// compared BACK to this proof.
import { useLang } from "@/context/LangContext";
import { COPY } from "@/components/landing/landingCopy";
import { Header } from "@/components/landing/landingPrimitives";
import { HeroSection } from "@/components/landing/HeroSection";
import { UnderstandSection } from "@/components/landing/UnderstandSection";
import { WinSection } from "@/components/landing/WinSection";
import { KeepSection } from "@/components/landing/KeepSection";
import { HandleSection } from "@/components/landing/HandleSection";
import { TalkVisionSection } from "@/components/landing/TalkVisionSection";

export default function FeaturesProof() {
  const { lang, setLang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="min-h-screen bg-white" data-testid="features-proof-root">
      <Header c={c} lang={lang} setLang={setLang} />
      <HeroSection c={c} />
      <UnderstandSection c={c} />
      <WinSection c={c} />
      <KeepSection c={c} />
      <HandleSection c={c} />
      <TalkVisionSection c={c} />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 text-[11px] text-[var(--jc-text-soft)]" data-testid="proof-stamp">
        {c.proof_stamp}
      </div>
    </div>
  );
}
